import { atomFamily } from "jotai/utils";

import { UnUploadedImage } from "components/PhotoUpload/types";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

const sessionAdditionalDocumentsAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<UnUploadedImage[]>(`additionalDocuments-${sessionId}`, [])
);

export const additionalDocumentsAtom = createDerivedSessionAtom<UnUploadedImage[]>(sessionAdditionalDocumentsAtom);
